// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/connect_component/connect-bg.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.connectMainDiv {
  width: 100%;
  height: 100%;
  color: #fff;
  font-family: Roboto;
  background: transparent;
  border-radius: 0 0 2.6vw 2.6vw;
}

.mainRow {
  display: flex;
  justify-content: center;
  align-items: center !important;
  width: 80%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 4.5vw 0vw;
  border-radius: 6vw;
}
@media (max-width: 992px) {
  .mainRow {
    width: 90%;
    padding: 24px;
  }
}

.leftDiv {
  margin-top: 4vh;
}

.leftTitle {
  font-family: "Helvetica";
  font-size: 3rem;
}

.leftTitleHead {
  font-weight: 500;
  margin-bottom: 5%;
}

.leftFormName {
  margin-right: 8%;
}

.rightImageDiv {
  display: flex;
  justify-content: center;
}

.rightImage {
  width: 100%;
}

.leftFormInput {
  color: #fff;
  width: 100%;
}

.btnSubmitItem {
  padding-top: 2rem;
  display: flex;
  justify-content: left;
}
@media (max-width: 768px) {
  .btnSubmitItem {
    padding-top: 0rem;
  }
}

.formInput {
  border-top: 0;
  border-right: 0;
  border-bottom: 2px solid transparent;
  border-image: linear-gradient(126deg, rgb(255, 255, 255) 0%, rgba(240, 89, 42, 0.59) 35%) 1;
  border-left: 0;
  color: #fff;
  border-radius: 0;
}

.formInput:hover,
.formInput:focus {
  border-top: 0;
  border-right: 0;
  border-bottom: 2px solid transparent;
  border-image: linear-gradient(126deg, rgb(255, 255, 255) 0%, rgba(240, 89, 42, 0.59) 35%) 1;
  border-left: 0;
  color: #fff;
  border-radius: 0;
}

.formInput::placeholder {
  color: white;
  opacity: 1; /* Firefox */
}

.leftTextBlock {
  background: rgb(240, 89, 42);
  width: 65px;
  height: 65px;
  z-index: -1;
}

.desktopImage {
  display: flex;
}

.letsConnectImg {
  display: flex;
  justify-content: center;
  height: 99.06291834vh;
  width: 59.5703125vw;
}

.mobileImage {
  display: none;
}

@media (max-width: 992px) {
  .leftFormInputDiv {
    display: flex;
    justify-content: center;
  }
  .rightImageDiv {
    margin: 12% 0 4% 0;
  }
}
@media (max-width: 768px) {
  .leftTitleHead {
    padding-bottom: 20px;
  }
  .leftFormInputHalf {
    width: 100%;
  }
  .leftFormInputFull {
    width: 100%;
  }
}
.connectMainDiv {
  width: 100%;
  background-color: #1d1a36;
  color: #fff;
}

.leftImage {
  width: 120%;
  z-index: 1;
  top: 50rem;
}

.leftTitle {
  font-family: Helvetica;
  display: flex;
  justify-content: flex-start;
  font-size: 3rem;
  z-index: 2;
  top: 10rem;
}

.leftTitleHead {
  text-align: left;
  font-weight: 700;
}

.leftFormInput {
  color: #fff;
}

.formInput {
  border-top: 0;
  border-right: 0;
  border-bottom: 2px solid transparent;
  border-image: linear-gradient(126deg, rgb(255, 255, 255) 0%, rgba(240, 89, 42, 0.59) 35%) 1;
  border-left: 0;
  color: #fff;
  background-color: transparent;
  border-radius: 0;
}

.formInput::placeholder {
  color: white;
  opacity: 1; /* Firefox */
}

@media (max-width: 992px) {
  .leftFormInputDiv {
    display: flex;
    justify-content: center;
  }
}
@media (max-width: 576px) {
  .desktopImage {
    display: none;
  }
  .mobileImage {
    display: flex;
  }
}
@media (min-width: 2100px) {
  .leftTitleHead {
    font-size: 4rem;
  }
  .formInput {
    font-size: 1vw;
  }
  .leftFormInputHalf {
    width: 100%;
  }
  .leftTextBlock {
    width: 120px;
    height: 120px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/LetConnect/letConnect.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,UAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;AACF;AAAE;EAXF;IAYI,UAAA;IACA,aAAA;EAGF;AACF;;AAAA;EACE,eAAA;AAGF;;AAAA;EACE,wBAAA;EACA,eAAA;AAGF;;AAAA;EACE,gBAAA;EACA,iBAAA;AAGF;;AAAA;EACE,gBAAA;AAGF;;AAAA;EACE,aAAA;EACA,uBAAA;AAGF;;AAAA;EACE,WAAA;AAGF;;AAAA;EACE,WAAA;EACA,WAAA;AAGF;;AAAA;EACE,iBAAA;EACA,aAAA;EACA,qBAAA;AAGF;AAFE;EAJF;IAKI,iBAAA;EAKF;AACF;;AAFA;EACE,aAAA;EACA,eAAA;EACA,oCAAA;EACA,2FAAA;EAMA,cAAA;EACA,WAAA;EACA,gBAAA;AAAF;;AAGA;;EAEE,aAAA;EACA,eAAA;EACA,oCAAA;EACA,2FAAA;EAMA,cAAA;EACA,WAAA;EACA,gBAAA;AALF;;AAQA;EACE,YAAA;EACA,UAAA,EAAA,YAAA;AALF;;AAQA;EACE,4BAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AALF;;AAQA;EACE,aAAA;AALF;;AAOA;EACE,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,aAAA;AAJF;;AAOA;EACE;IACE,aAAA;IACA,uBAAA;EAJF;EAOA;IACE,kBAAA;EALF;AACF;AAQA;EACE;IACE,oBAAA;EANF;EASA;IACE,WAAA;EAPF;EAUA;IACE,WAAA;EARF;AACF;AAgBA;EACE,WAAA;EACA,yBAAA;EACA,WAAA;AAdF;;AAiBA;EACE,WAAA;EACA,UAAA;EACA,UAAA;AAdF;;AAiBA;EACE,sBAAA;EACA,aAAA;EACA,2BAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;AAdF;;AAiBA;EACE,gBAAA;EAEA,gBAAA;AAfF;;AAkBA;EACE,WAAA;AAfF;;AAkBA;EACE,aAAA;EACA,eAAA;EACA,oCAAA;EACA,2FAAA;EAMA,cAAA;EACA,WAAA;EACA,6BAAA;EACA,gBAAA;AApBF;;AAuBA;EACE,YAAA;EACA,UAAA,EAAA,YAAA;AApBF;;AAuBA;EACE;IACE,aAAA;IACA,uBAAA;EApBF;AACF;AA6BA;EACE;IACE,aAAA;EA3BF;EA8BA;IACE,aAAA;EA5BF;AACF;AAqCA;EACE;IACE,eAAA;EAnCF;EAsCA;IACE,cAAA;EApCF;EAuCA;IACE,WAAA;EArCF;EAwCA;IACE,YAAA;IACA,aAAA;EAtCF;AACF","sourcesContent":[".connectMainDiv {\n  width: 100%;\n  height: 100%;\n  color: #fff;\n  font-family: Roboto;\n  background: transparent;\n  border-radius: 0 0 2.6vw 2.6vw;\n}\n\n.mainRow {\n  display: flex;\n  justify-content: center;\n  align-items: center !important;\n  width: 80%;\n  background-image: url(\"../../assets/images/connect_component/connect-bg.webp\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  padding: 4.5vw 0vw;\n  border-radius: 6vw;\n  @media (max-width: 992px) {\n    width: 90%;\n    padding: 24px;\n  }\n}\n\n.leftDiv {\n  margin-top: 4vh;\n}\n\n.leftTitle {\n  font-family: \"Helvetica\";\n  font-size: 3rem;\n}\n\n.leftTitleHead {\n  font-weight: 500;\n  margin-bottom: 5%;\n}\n\n.leftFormName {\n  margin-right: 8%;\n}\n\n.rightImageDiv {\n  display: flex;\n  justify-content: center;\n}\n\n.rightImage {\n  width: 100%;\n}\n\n.leftFormInput {\n  color: #fff;\n  width: 100%;\n}\n\n.btnSubmitItem {\n  padding-top: 2rem;\n  display: flex;\n  justify-content: left;\n  @media (max-width: 768px) {\n    padding-top: 0rem;\n  }\n}\n\n.formInput {\n  border-top: 0;\n  border-right: 0;\n  border-bottom: 2px solid transparent;\n  border-image: linear-gradient(\n      126deg,\n      rgba(255, 255, 255, 1) 0%,\n      rgba(240, 89, 42, 0.59) 35%\n    )\n    1;\n  border-left: 0;\n  color: #fff;\n  border-radius: 0;\n}\n\n.formInput:hover,\n.formInput:focus {\n  border-top: 0;\n  border-right: 0;\n  border-bottom: 2px solid transparent;\n  border-image: linear-gradient(\n      126deg,\n      rgba(255, 255, 255, 1) 0%,\n      rgba(240, 89, 42, 0.59) 35%\n    )\n    1;\n  border-left: 0;\n  color: #fff;\n  border-radius: 0;\n}\n\n.formInput::placeholder {\n  color: white;\n  opacity: 1; /* Firefox */\n}\n\n.leftTextBlock {\n  background: rgba(240, 89, 42, 1);\n  width: 65px;\n  height: 65px;\n  z-index: -1;\n}\n\n.desktopImage {\n  display: flex;\n}\n.letsConnectImg {\n  display: flex;\n  justify-content: center;\n  height: 99.06291834002677vh;\n  width: 59.5703125vw;\n}\n\n.mobileImage {\n  display: none;\n}\n\n@media (max-width: 992px) {\n  .leftFormInputDiv {\n    display: flex;\n    justify-content: center;\n  }\n\n  .rightImageDiv {\n    margin: 12% 0 4% 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .leftTitleHead {\n    padding-bottom: 20px;\n  }\n\n  .leftFormInputHalf {\n    width: 100%;\n  }\n\n  .leftFormInputFull {\n    width: 100%;\n  }\n}\n\n@media (max-width: 500px) {\n  // .leftTitleHead {\n  //   padding-top: 15%;\n  // }\n}\n.connectMainDiv {\n  width: 100%;\n  background-color: #1d1a36;\n  color: #fff;\n}\n\n.leftImage {\n  width: 120%;\n  z-index: 1;\n  top: 50rem;\n}\n\n.leftTitle {\n  font-family: Helvetica;\n  display: flex;\n  justify-content: flex-start;\n  font-size: 3rem;\n  z-index: 2;\n  top: 10rem;\n}\n\n.leftTitleHead {\n  text-align: left;\n  // padding-top: 6%;\n  font-weight: 700;\n}\n\n.leftFormInput {\n  color: #fff;\n}\n\n.formInput {\n  border-top: 0;\n  border-right: 0;\n  border-bottom: 2px solid transparent;\n  border-image: linear-gradient(\n      126deg,\n      rgba(255, 255, 255, 1) 0%,\n      rgba(240, 89, 42, 0.59) 35%\n    )\n    1;\n  border-left: 0;\n  color: #fff;\n  background-color: transparent;\n  border-radius: 0;\n}\n\n.formInput::placeholder {\n  color: white;\n  opacity: 1; /* Firefox */\n}\n\n@media (max-width: 992px) {\n  .leftFormInputDiv {\n    display: flex;\n    justify-content: center;\n  }\n}\n\n// @media (max-width: 768px) {\n//   .leftTitleHead {\n//     padding-top: 8%;\n//   }\n// }\n\n@media (max-width: 576px) {\n  .desktopImage {\n    display: none;\n  }\n\n  .mobileImage {\n    display: flex;\n  }\n}\n\n// @media (max-width: 483px) {\n//   .leftTitleHead {\n//     padding-top: 15%;\n//   }\n// }\n\n@media (min-width: 2100px) {\n  .leftTitleHead {\n    font-size: 4rem;\n  }\n\n  .formInput {\n    font-size: 1vw;\n  }\n\n  .leftFormInputHalf {\n    width: 100%;\n  }\n\n  .leftTextBlock {\n    width: 120px;\n    height: 120px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
